module.exports = __webpack_public_path__ + "static/media/laugh-wink.2927e490.svg";